import React from "react";
import { StampPage } from "./styled/landing";

const Stamp = () => {
  const url = getAppStoreUrl();

  return (
    <StampPage>
      <h2 className="logo" onClick={() => navigate("/")}>
        MONOTI
      </h2>
      <img
        src="/img/landing/stamp.png"
        onClick={() => {
          if (url) {
            window.location.href = url;
          }
        }}
      />
    </StampPage>
  );
};

export default Stamp;
